export default __webpack_public_path__ + "static/media/inca2.aa48481f.PNG";